import { Box, Palette, Stack, Typography } from "@mui/material";
import { Sparkles } from "lucide-react";
import { useEffect, useState } from "react";
import {
  greetingContainerStyle,
  getGreetingIconBoxStyle,
  greetingTitleStyle,
  getGreetingCaretStyle,
  getGreetingSubtitleStyle,
} from "../styles/askDostStyles";
import { TYPE_INTERVAL_MS } from "../utils/constants";

interface IAskDostGreetingProps {
  firstName?: string;
  palette: Palette;
  translate: (text: string, options?: any) => string;
}

export const AskDostGreeting = ({
  firstName,
  palette,
  translate,
}: IAskDostGreetingProps) => {
  const fullGreeting = translate("ask_dost_greeting", { firstName: firstName });
  const [typedLength, setTypedLength] = useState(0);

  useEffect(() => {
    setTypedLength(0);
    let index = 0;
    const timer = setInterval(() => {
      index += 1;
      setTypedLength(index);
      if (index >= fullGreeting.length) {
        clearInterval(timer);
      }
    }, TYPE_INTERVAL_MS);

    return () => clearInterval(timer);
  }, [fullGreeting]);

  return (
    <Stack sx={greetingContainerStyle}>
      <Box sx={getGreetingIconBoxStyle(palette)}>
        <Sparkles size={28} strokeWidth={2.5} />
      </Box>

      <Typography variant="h4" sx={greetingTitleStyle}>
        {fullGreeting.slice(0, typedLength)}

        <Typography component="span" sx={getGreetingCaretStyle(palette)} />
      </Typography>

      <Typography variant="body2" sx={getGreetingSubtitleStyle(palette)}>
        {translate("ask_about_documents")}
      </Typography>
    </Stack>
  );
};
